import _ from 'lodash'

const STORAGE_KEY_PREFIX = 'outsourcedEditToken:'

/**
 * 編集トークンを URL から取得する（#token=、移行期間中は ?token= も可）
 * 再読み込みに備えてタブ内（sessionStorage）に記事ごとに保持する。
 * isStored が false のとき（プライベートモード等）は URL からトークンを消さないこと
 */
export function readEditToken(articleId, location) {
  const hashToken = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token')
  const urlToken = hashToken || _.get(location, 'query.token') || null
  const storageKey = `${STORAGE_KEY_PREFIX}${articleId}`

  try {
    if (urlToken) {
      window.sessionStorage.setItem(storageKey, urlToken)
      return { token: urlToken, isStored: true }
    }
    return { token: window.sessionStorage.getItem(storageKey), isStored: true }
  } catch (error) {
    return { token: urlToken, isStored: false }
  }
}

/**
 * 無効になった編集トークンをタブ内から消す
 */
export function forgetEditToken(articleId) {
  try {
    window.sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${articleId}`)
  } catch (error) {
    // sessionStorage が使えない環境では保持していないので何もしない
  }
}

/**
 * アドレスバーからトークン（#token= / ?token=）を消す
 */
export function removeTokenFromAddressBar() {
  if (window.location.hash || window.location.search) {
    window.history.replaceState(window.history.state, '', window.location.pathname)
  }
}
